export const leftMenuAnchor = () => {
    function scrollToTarget(target) {
        $('html,body').animate({
            scrollTop: target.offset().top - 100
        }, 1000);
    }

    $(window).on('load', function () {
        if (window.location.hash) {
            let target = $(window.location.hash);

            if (target.length) {
                scrollToTarget(target);
            }
        }
    });

    $('a[href*="#"]').click(function (e) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                e.preventDefault();
                scrollToTarget(target);
            }
        }
    });
}
